module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page7.6f573490.png";